import apiClient from '@/services/axios'

export async function post(note) {

  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-notes', note);
  if (response) {
    console.log(response);
    return response.data;
  }

  throw new Error('Unable to create a note.');
}
